// TODO (JM): maybe move to ckauth?
export enum WebUserType {
  Manager = 32751,
  AssistantManager = 32752,
  Supervisor = 32753,
  MaterialsClerk = 32754,
  ViewOnly = 32755,
  // NoAccess = 32756, TODO: What is this?
  Superuser = 32757,
  Production = 32758,
}

export enum MobileUserType {
  Supervisor = 35030,
  Auditor = 35035,
  Production = 35040,
  Sanitor = 35045,
  SanitorWS = 35050,
  Purchaser = 35055,
  // NoAccess = 35060, TODO: What is this?
}

export type UserType = WebUserType | MobileUserType;

export type RestrictedAccess<T extends object = object> = T & {
  restrictedTypes?: UserType[];
  hide?: MaybeRefOrGetter<boolean>;
};

export type MaybeRestrictedAccess<T extends object = object> = T | RestrictedAccess<T>;

export type UserAuthorization = {
  type?: UserType | MobileUserType;
};

// TODO: calculate permissions based on user data, for now will be directly tied to user type
export function hasUserAccess<T extends object = object>(
  item: MaybeRestrictedAccess<T>,
  user: UserAuthorization | undefined,
) {
  if (!("restrictedTypes" in item) || !item.restrictedTypes || item.restrictedTypes.length === 0) return true;
  if (!user?.type) return false;

  return item.restrictedTypes.some((type) => type === user.type);
}

// TODO: calculate permissions based on user data, for now will be directly tied to user type
export function hideSidebarItem<T extends object = object>(item: MaybeRestrictedAccess<T>) {
  if (!("hide" in item) || (!isRef(item.hide) && typeof item.hide !== "function")) return false;
  if (typeof item.hide === "function") return item.hide();
  return item.hide.value;
}
